<div class="tagHighlightDs__cont tagHighlightDs__cont--{{type}}">
  <div class="tagHighlightDs__icon">
    <app-ds-icon
      [icon]="tagIcon"
      [size]="iconSize"
      [color]="iconColor">
    </app-ds-icon>
  </div>
  <ng-container *ngIf="useText">
    <div class="tagHighlightDs__text tagHighlightDs__text--{{type}}">
      <app-ds-typography
        [text]="title"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Primary"
        [size]="titleFontSize">
      </app-ds-typography>
      <ng-container *ngIf="useDescription">
        <app-ds-typography
          [text]="description"
          [fontFamily]="fontFamily.Regular"
          [color]="fontColor.Secondary"
          [size]="descriptionFontSize">
        </app-ds-typography>
      </ng-container>
    </div>
  </ng-container>
</div>